// Cross-tab signal from the knowledge-graph editor's publish / unpublish to every open report editor
// whose Concierge tab shows the model's card (MI-30409). The card polls only while a run profiles,
// so without this a publish made in another tab is invisible until a reload.

export const KG_PUBLICATION_CHANNEL = 'concierge-kg-publication';

export interface KgPublicationChangedMessage {
    type: 'publication_changed';
    modelUid: string;
}

const isSupported = (): boolean => typeof BroadcastChannel !== 'undefined';

export function postKgPublicationChanged(modelUid: string): void {
    if (!isSupported()) return;
    const channel = new BroadcastChannel(KG_PUBLICATION_CHANNEL);
    try {
        const message: KgPublicationChangedMessage = { type: 'publication_changed', modelUid };
        channel.postMessage(message);
    } finally {
        channel.close();
    }
}

export function subscribeKgPublicationChanged(handler: (modelUid: string) => void): () => void {
    if (!isSupported()) return () => {};
    const channel = new BroadcastChannel(KG_PUBLICATION_CHANNEL);
    channel.onmessage = (event: MessageEvent<KgPublicationChangedMessage>) => {
        const data = event.data;
        if (data?.type === 'publication_changed' && typeof data.modelUid === 'string') {
            handler(data.modelUid);
        }
    };
    return () => channel.close();
}
